import _ from 'lodash';
import QuestionSchema from '@ax2/common/model/schemas/QuestionSchema';
import QuestionType from '@ax2/common/model/QuestionType';
import TextQuestionSchema from '@ax2/common/model/schemas/TextQuestionSchema';
import GridQuestionSchema from '@ax2/common/model/schemas/GridQuestionSchema';
import ListQuestionSchema from '@ax2/common/model/schemas/ListQuestionSchema';
import { isTemplateEditable } from '@ax2/common/helpers/template';

export const isEditable = (question: QuestionSchema): boolean => {
  switch (question.questionType) {
    case QuestionType.Empty:
      return true;
    case QuestionType.OpenEndedNumeric:
    case QuestionType.OpenEndedText:
      return isOpenEndedEditable(question as TextQuestionSchema);
    case QuestionType.CheckboxGrid:
    case QuestionType.RadioButtonGrid:
    case QuestionType.RadioButtonGridRow:
    case QuestionType.RatingList:
      return isGridEditable(question as GridQuestionSchema);
    case QuestionType.DropdownMenu:
    case QuestionType.CheckboxList:
    case QuestionType.RadioButtonList:
    case QuestionType.ContinuousSumList:
    case QuestionType.RankingList:
      return isListEditable(question as ListQuestionSchema);
    default:
      return true;
  }
};

const isOpenEndedEditable = (question: TextQuestionSchema): boolean =>
  isTemplateEditable(question.content) || !question.isLocked;

const isGridEditable = (question: GridQuestionSchema): boolean =>
  isTemplateEditable(question.content) ||
  _.findIndex(question.columns, c => isTemplateEditable(c.content)) !== -1 ||
  _.findIndex(question.rows, r => isTemplateEditable(r.content)) !== -1 ||
  !question.isLocked;

const isListEditable = (question: ListQuestionSchema): boolean =>
  isTemplateEditable(question.content) ||
  _.findIndex(question.answerOptions, o => isTemplateEditable(o.content)) !==
    -1 ||
  !question.isLocked;
